import React, { memo } from "react";

const AppCalendarCheckIcon = ({ color = "#666666", className }) => {
	return (
		<svg className={className} width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
			<path d="M8 2v4" />
			<path d="M16 2v4" />
			<rect width="18" height="18" x="3" y="4" rx="2" />
			<path d="M3 10h18" />
			<path d="m9 16 2 2 4-4" />
		</svg>
	);
};

export default memo(AppCalendarCheckIcon);
